import PropTypes from "prop-types";
import { useState } from "react";
import { faqs } from "../../data";
import AccordionItem from "./AccordionItem";
import bg20 from "../../assets/images/background/bg-20.png";
import separator from "../../assets/images/icons/separator.svg";

const NO_SELECTION = null;
const BG_ALT = "Background";
const SEP_ALT = "Separator";

const Accordion = () => {
  const [clicked, setClicked] = useState(NO_SELECTION);

  const handleToggle = (index) => {
    setClicked(clicked === index ? NO_SELECTION : index);
  };

  //console.log(faqs)

  return (
    <section className="menu-two">
      <div className="left-bg">
        <img src={bg20} alt={BG_ALT} />
      </div>
      <article className="auto-container">
        <header className="title-box centered">
          <div className="pattern-image">
            <img src={separator} alt={SEP_ALT} />
          </div>
        </header>
        <div className="container">
          <ul className="accordion">
            {faqs.map((faq, index) => (
              <AccordionItem
                onToggle={() => handleToggle(index)}
                active={clicked === index}
                key={faq.id}
                faq={faq}
              />
            ))}
          </ul>
        </div>
      </article>
    </section>
  );
};

AccordionItem.propTypes = {
  onToggle: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  faq: PropTypes.shape({
    id: PropTypes.string.isRequired,
    question: PropTypes.string,
    answer: PropTypes.string,
  }).isRequired,
};

export default Accordion;
